import { useEffect, useState } from "react"

/**
 * Placeholder "Please wait..." indicator while fetching form.
 * Appears after 500ms.
 *
 * @returns {object} JSX
 */
export default function Loading() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handle = setTimeout(() => setVisible(true), 250)
    return () => { clearTimeout(handle) }
  }, [])

  return (
    <h2
      style={{
        opacity: visible ? "100" : "0",
        transition: "opacity 0.5s",
      }}
    >Please wait&hellip;</h2>
  )
}
